import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const qmsComputed = {
	...mapGetters('qmsCommonStore', Object.keys(getters)),
	...mapState('qmsCommonStore', Object.keys(state))
};
export const qmsMethods = {
	...mapActions('qmsCommonStore', Object.keys(actions)),
	...mapMutations('qmsCommonStore', Object.keys(mutations))
};
